import {CABINET_BOXES, SQFT_FEATURES} from "../../../sqft/constants";
import {getNextWizardSteps} from "../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import store from "../../../../store";

/**
 * Categorize conflicting cart items into items to remove and items to update
 * @returns {Object} Object with itemsToRemove and itemsToUpdate arrays
 */
export const categorizeConflictingCartItemsFromStore = () => {
  const state = store.getState();
  const { wizardConflictingSteps, wizardList, wizardActiveStep, wizardSelectedValues, wizardActiveItem } = state.wizardState;
  const { cartItems } = state.cartState;
  const { sqftCartItems } = state.sqftResourceState;
  const cartItemsAndSQFTTempCartItems = [...sqftCartItems, ...cartItems];

  return categorizeConflictingCartItems(
    wizardConflictingSteps,
    cartItemsAndSQFTTempCartItems,
    wizardList,
    wizardActiveStep,
    wizardSelectedValues,
    wizardActiveItem,
  );
};

export const categorizeConflictingCartItems = (
  wizardConflictingSteps,
  cartItemsAndSQFTTempCartItems,
  wizardList,
  wizardActiveStep,
  wizardSelectedValues,
  wizardActiveItem,
) => {
  const itemsToRemove = [];
  const itemsToUpdate = [];

  const sortedWizardConflictingSteps = wizardConflictingSteps?.sort((a, b) => a.stepIndex - b.stepIndex);

  for (const wizardConflictingStep of sortedWizardConflictingSteps) {
    const cartItem = cartItemsAndSQFTTempCartItems.find(
      item => wizardConflictingStep.cartItemId === item.id
    );

    if (!cartItem) {
      continue;
    }

    const partId = cartItem.partId;
    const isSlab = partId === SQFT_FEATURES.slabs;
    const isCabinetBox = CABINET_BOXES.includes(partId);
    const isInstallation = partId === "installation";

    // Skip conflict for slab, cabinet boxes, and installation
    if (isSlab || isCabinetBox || isInstallation) {
      continue;
    }

    const wizardGroup = wizardActiveItem.wizardGroups.find(
      wizGroup => wizGroup.id === wizardConflictingStep.wizardGroupId
    );

    if (!wizardGroup) {
      console.error('wizardGroup was not found for the wizardConflictingStep');
      continue;
    }

    const wizardSteps = getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

    // Determine if feature should be updated or removed
    let sameNewWizardStep = wizardSteps.find(step => step.stepIndex === wizardConflictingStep.stepIndex);
    if (!sameNewWizardStep || sameNewWizardStep.stepGroups?.[0]?.groupName !== wizardGroup.groupName) {
      sameNewWizardStep = wizardSteps.find(step => step.stepGroups?.[0]?.groupName === wizardGroup.groupName)
    }

    const shouldUpdate = sameNewWizardStep && sameNewWizardStep.stepGroups?.[0]?.groupName === wizardGroup.groupName;

    if (shouldUpdate) {
      itemsToUpdate.push({
        cartItem,
        wizardConflictingStep
      });
    } else {
      itemsToRemove.push({
        cartItem,
        wizardConflictingStep
      });
    }
  }

  return {
    itemsToRemove,
    itemsToUpdate
  };
};
